module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-form"
  }, [_c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/title')))]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, [_c('div', {
    staticClass: "w5-field"
  }, [_c('span', {
    staticClass: "al w5-z-index-1",
    class: {
      animated: _vm.animatedEmail, focused: _vm.isFocusedEmail, unfocused: !_vm.isFocusedEmail
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/email'))), _c('span', {
    staticClass: "required-field"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    class: {
      haserror: _vm.form_ErrorMessage
    },
    attrs: {
      "name": "email",
      "type": "text",
      "id": "email",
      "aria-describedby": "emailHelp",
      "placeholder": _vm._f("ftc")("main/email *"),
      "disabled": _vm.isInputDisabled,
      "readonly": _vm.isInputDisabled
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "focus": _vm.OnFocus,
      "blur": _vm.OnBlur,
      "keyup": _vm.OnKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w5-field"
  }, [_c('span', {
    staticClass: "al w5-z-index-1",
    class: {
      animated: _vm.animatedPassword, focused: _vm.isFocusedPassword, unfocused: !_vm.isFocusedPassword
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/password'))), _c('span', {
    staticClass: "required-field"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    class: {
      haserror: _vm.form_ErrorMessage
    },
    attrs: {
      "name": "password",
      "type": "password",
      "id": "password",
      "aria-describedby": "passwordHelp",
      "placeholder": _vm._f("ftc")("main/password *"),
      "disabled": _vm.isInputDisabled,
      "readonly": _vm.isInputDisabled
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "focus": _vm.OnFocus,
      "blur": _vm.OnBlur,
      "keyup": _vm.OnKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form_ErrorMessage !== false),
      expression: "form_ErrorMessage !== false"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.form_ErrorMessage)),
      expression: "localeFtc(form_ErrorMessage)"
    }],
    staticClass: "alert alert-danger w5-error-block",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "role": "alert"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_admin),
      expression: "!is_admin"
    }],
    staticClass: "w5-field w5-new-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    staticClass: "w5-checkbox-field",
    attrs: {
      "id": "wcp_login_form_remember",
      "type": "checkbox",
      "true-value": 1,
      "false-value": 0
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : _vm._q(_vm.rememberMe, 1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (1) : (0);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "wcp_login_form_remember"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/remember_me')))])]), _vm._v(" "), _c('div', {
    staticClass: "w5-field text-center"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form_Loading),
      expression: "form_Loading"
    }],
    attrs: {
      "src": "/static/img/loading32.gif"
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.form_Loading),
      expression: "!form_Loading"
    }],
    ref: "button",
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/enter')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.form_Loading),
      expression: "!form_Loading"
    }],
    staticClass: "w5-field"
  }, [_c('router-link', {
    staticClass: "pull-left",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('page/user_register')))]), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right",
    attrs: {
      "to": "/forget"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/forgot')))])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2FADialogModal),
      expression: "show2FADialogModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hide2FADialogModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container narrow",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('twofa/check_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hide2FADialogModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.fields2FA && _vm.fields2FA.fields) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.fields2FA.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row)
      }
    }, _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "fieldInModal": true,
          "removeRightPadding": true,
          "crud": "twofa",
          "action": "check",
          "Field": field
        },
        on: {
          "focus": function($event) {
            return _vm.onFocus2FA(field)
          },
          "enterKeyDown": _vm.submit2FAForm
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }), 1) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-in-dialog",
    on: {
      "click": _vm.submit2FAForm
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('twofa/check')))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-602c2ee0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Login.vue
// module id = 441
// module chunks = 0